import {Button} from '@mui/material'
import {trackEvent} from '@hconnect/common/logging/Analytics'
import {useMutation, useQueryClient} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useSnackbar} from 'notistack'
import {useSelector} from 'react-redux'
import {useParams} from 'react-router'

import {useTranslation} from '../../../hooks/useTranslation'
import {selectLoggedInUserProfile} from '../../../modules/LoggedInUser.selectors'
import {RoleAssignment} from '../../../modules/ManageUsers.selectors'
import {deleteUserRole} from '../../WidgetUserCreation/hooks/useCreateWidgetUser'

const deleteUserRoles = async (roles: RoleAssignment[]) => {
  for (const userRole of roles) {
    await deleteUserRole(userRole)
  }
}
export const useDeleteUserRoles = () => {
  const {enqueueSnackbar, closeSnackbar} = useSnackbar()
  const {t} = useTranslation()
  const queryClient = useQueryClient()
    const loggedInUserProfile = useSelector(selectLoggedInUserProfile)
    const {userId} = useParams<{userId: string}>()

  return useMutation(deleteUserRoles, {
    onSuccess: () => {
        trackEvent('cscQuickPreviewDeleteUserRolesSuccess', {
            userId: loggedInUserProfile?.user_id,
            product: 'adminConsole',
            previewedUserId: userId
        })
      void queryClient.invalidateQueries(['roles'])
    },
    onError: (e) => {
      const error = e as AxiosError
        trackEvent('cscQuickPreviewDeleteUserRolesError', {
            userId: loggedInUserProfile?.user_id,
            product: 'adminConsole',
            previewedUserId: userId
        })
      enqueueSnackbar(
        error.response?.status === 304
          ? t('quickPreview.addPermissions.form.errorRoleExistsMsg')
          : (error.response?.data as any)?.message || t('errorboundary.error'),
        {
          anchorOrigin: {vertical: 'bottom', horizontal: 'center'},
          variant: 'error',
          action: (key) => (
            <Button
              style={{color: '#FFFFFF', borderColor: 'transparent'}}
              onClick={() => closeSnackbar(key)}
            >
              Close
            </Button>
          )
        }
      )
    }
  })
}
